"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardExtensionContext = void 0;
exports.DashboardExtensionContextProvider = DashboardExtensionContextProvider;
exports.useDashboardExtensionContext = useDashboardExtensionContext;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
exports.DashboardExtensionContext = (0, react_1.createContext)(undefined);
function DashboardExtensionContextProvider(_a) {
    var value = _a.value, children = _a.children;
    return (react_1.default.createElement(exports.DashboardExtensionContext.Provider, { value: value }, children));
}
function useDashboardExtensionContext() {
    var ctx = (0, react_1.useContext)(exports.DashboardExtensionContext);
    if (!ctx) {
        throw new Error("Your component should be wrapped in a 'DashboardExtensionContextProvider' to use the 'useDashboardExtensionContext' hook.");
    }
    return ctx;
}
//# sourceMappingURL=DashboardExtensionContextProvider.js.map